
<div class="MC-text-info-variantes">
    <div class="MC-text-info-variantes-div">
        <h5>
            {{infoVariantes}}
        </h5>
    </div>
    <div class="MC-text-info-variantes-nbVariante-div">
        {{'search.variantes'|translate}} ({{variantes.variants.length}})
    </div>
</div>

<div class="MC-row-listVariantes">
    <div *ngFor="let variante of variantes.variants" class="MC-row-variante-global" (click)="SelectFormule(variante, variantes.marketColorId)">
        <div class="MC-row-variante">
            <div class="MC-row-vignetteCouleur">
                <img class="MC-row-imgCouleur" src="{{variante.colorOnDisplayUri}}" alt="" />
            </div>
            <div class="MC-row-varianteDescription">
                {{variantes.akzoCode}}{{variante.variantSuffix}}
                <img *ngIf="variante.variantSuffix && variante.variantSuffix.length > 1 && variante.variantSuffix[1] && listIconVariantSuffix.indexOf(variante.variantSuffix[1].toLowerCase()) > -1" class="MC-row-imgSuffix" src="assets/MixitCloud/{{variante.variantSuffix[1].toLowerCase()}}.svg" alt="" />
            </div>
            <div class="MC-row-bestVariante">
                {{variante.mostLikelyVariantProbability}}%
            </div>
            <div class="MC-row-haveRadar">
                <img *ngIf="variante.haveRadar" class="MC-row-haveRadar-img" src="assets/MixitCloud/RadarRecul.png"/>
            </div>
            <!--<div class="MC-row-action">
        <div *ngIf="false" class="MC-row-action-div" title="Enregistrer en tant que favoris">
            <i *ngIf="teinte.isFavorite; else elseBlockIsFavorite" class="MC-row-action-icon MC-row-action-star fas fa-star"></i>
            <ng-template #elseBlockIsFavorite>
                <i class="MC-row-action-icon MC-row-action-star far fa-star"></i>
            </ng-template>
        </div>
        <div class="MC-row-action-div" title="Voir plus d'informations">
            <i class="MC-row-action-icon MC-row-action-info fas fa-info"></i>
        </div>
    </div>-->
        </div>
        <mat-divider class="MC-row-divider"></mat-divider>
    </div>
</div>
